import MotivationElementNodeType from '../MotivationElementNodeType';
import {MOTIVATION_OUTCOME} from '../../metamodel/Concept';

export default class OutcomeNodeType extends MotivationElementNodeType {
	static get typeName() {
		return MOTIVATION_OUTCOME;
	}
}
